export function shortTime(timeStamp) {
  const [, , , hour, minutes] = timeStamp.split(/[^0-9]/)
  const formattedHour = ((Number(hour) + 11) % 12) + 1
  const period = Number(hour) >= 12
    ? 'pm'
    : 'am'
  return `${formattedHour}:${minutes}${period}`
}

export function getHour(timeStamp) {
  const [, , , hour] = timeStamp.split(/[^0-9]/)
  const formattedHour = Number(hour)
  return formattedHour
}

export function progress({ start, end, current = Date.now() }) {
  const total = end - start
  const spent = Math.abs(start - current)
  return (spent / total)
}
